import Slider from './slider';

export default Slider;
export type * from './types';
